module.exports = __webpack_public_path__ + "img/login_banner.47d09895.png";